export default "__VITE_ASSET__CvlMhHTV__"